export default "__VITE_ASSET__7GsRsGE9__"